import { publicRequest } from "../../auth/requestMethods";
import { loginFailure, loginStart, loginSuccess } from "./AuthActions";

export const login = async (user, dispatch) => {

   dispatch(loginStart());
   return publicRequest().post("/users/login", user).then(res=>{
     
    dispatch(loginSuccess({accessToken:res.data.accessToken,...res.data.user}));
    return res
   }).catch(err=> {
    dispatch(loginFailure());
    return err.response
   })
};